import { Dictionary } from "@insite/client-framework/Common/Types";

const getMatchingDataFromDictionary = <T = any>(
    data: any[] | undefined | null,
    dictionary: Dictionary<T> | undefined,
    property = "id",
): NonNullable<T>[] => {
    return (
        (dictionary &&
            data?.reduce((result, x) => {
                const entry = dictionary[x[property]];

                if (entry) {
                    result.push(entry);
                }

                return result;
            }, [])) ||
        []
    );
};

export default getMatchingDataFromDictionary;
